import {Component, Input, OnInit} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../../../_services/common.service';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
})
export class ReadMoreComponent implements OnInit {

  @Input() projectType = 'ap';
  projectObj: any;
  projectTypeImage = '';
  darkProjectTypeImage = '';

  constructor(public translate: TranslateService,
              private commonService: CommonService,
              private modalCtrl: ModalController,
              private navParams: NavParams) {
  }

  ngOnInit() {
    this.projectObj = this.commonService.getProjectDetails(this.projectType);
    // this.projectType = this.navParams.data.projectType;
    // [this.projectType, this.projectTypeImage, this.darkProjectTypeImage] = this.commonService.getProjectLogo(this.projectType);
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }

}
